import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[inputDisable]'
})
export class InputDisableControlDirective implements OnChanges{

    @Input() condition : any;
  
    constructor(private ngControl : NgControl) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.disableControl()
    }

    disableControl () {
        const action = this.condition ? 'enable' : 'disable';
        this.ngControl.control[action]();
    }
}